import type {To} from 'react-router'

export function extractTo(href: string): To {
  if (href.startsWith(window.location.origin)) {
    const {pathname, search, hash} = new URL(href)
    return {pathname, search, hash}
  } else {
    return href
  }
}
